import React, { Suspense, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import Footer from '../components/Footer';
import Loading from '../components/Loading';
import Navigation from '../components/Navigation';
import { useLocalization } from '../contexts/LocalizationContext';
import useNotifications from '../hooks/useNotifications';

export default function BaseLayout() {
  const { localize } = useLocalization();
  const { notify } = useNotifications();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('logout') === 'success') {
      notify({
        content: localize('auth.logout.success') || 'Olet kirjautunut ulos järjestelmästä.',
        variant: 'success'
      });
      params.delete('logout');
      const newSearch = params.toString();
      navigate(location.pathname + (newSearch ? `?${newSearch}` : ''), { replace: true });
    }
  }, []);

  return (
    <div className='position-relative overflow-hidden' style={{ minHeight: '100vh' }}>
      <Navigation />
      <Container fluid='xxl' id='main-container' className='px-3 px-md-4'>
        <Suspense
          fallback={
            <Loading
              position='absolute-center'
              label={localize('common.loading')}
            />
          }>
          <Outlet />
        </Suspense>
      </Container>
      <Footer />
    </div>
  );
}
